import React from "react";
import SearchableSelect from "../SearchableSelect";
import BuildingTypePicker from "./BuildingTypePicker";

export const STAGES = [
  { value: "concept", label: "კონცეფცია" },
  { value: "design", label: "პროექტირების ეტაპი" },
  { value: "tender", label: "ტენდერი" },
  { value: "construction", label: "მშენებლობა" },
];
const CURRENCIES = [
  { value: "GEL", label: "ლარი — ₾" },
  { value: "USD", label: "აშშ დოლარი — $" },
  { value: "EUR", label: "ევრო — €" },
];

export default function GeneralInfoStep({ form, setField, customers, typeIndex, nameMissing, showErrors, docNumber, onRefreshRate }) {
  const field = (key) => ({ value: form[key] ?? "", onChange: (e) => setField(key, e.target.value) });
  const customerName = customers.find((c) => String(c.id) === String(form.customerId))?.name || "";

  return (
    <div className="bgrid">
      <div className="bcol">
        <section className="bcard">
          <div className="bcard-h">
            <h4>პროექტი</h4>
            <p>დასახელება, ადგილი, დამკვეთი, ეტაპი</p>
          </div>
          <div className="fgrid g2">
            <div className={`fld wide${showErrors && nameMissing ? " bad" : ""}`}>
              <label htmlFor="ps-name">დასახელება *</label>
              <input id="ps-name" className="nmbig" autoFocus {...field("name")} />
              {showErrors && nameMissing && <div className="ferr">დასახელება სავალდებულოა</div>}
            </div>
            <div className="fld">
              <label htmlFor="ps-loc">მდებარეობა</label>
              <input id="ps-loc" {...field("location")} />
            </div>
            <div className={`fld${showErrors && !form.customerId ? " bad" : ""}`}>
              <label htmlFor="ps-client">დამკვეთი *</label>
              <SearchableSelect
                id="ps-client"
                options={customers.map((c) => ({ value: c.id, label: c.name }))}
                value={form.customerId}
                onChange={(v) => setField("customerId", v)}
                placeholder="აირჩიეთ დამკვეთი"
              />
              {showErrors && !form.customerId && <div className="ferr">დამკვეთი სავალდებულოა</div>}
            </div>
            <div className="fld">
              <label htmlFor="ps-date">თარიღი</label>
              <input id="ps-date" type="date" {...field("date")} />
            </div>
            <div className="fld">
              <label htmlFor="ps-stage">ეტაპი</label>
              <select id="ps-stage" {...field("stage")}>
                {STAGES.map((s) => (
                  <option key={s.value} value={s.value}>
                    {s.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </section>

        <section className="bcard">
          <div className="bcard-h">
            <h4>შენობის ტიპი</h4>
            <p>შენობების კლასიფიკატორიდან — აკრიფეთ ან დააზუსტეთ დონეებით</p>
          </div>
          <BuildingTypePicker index={typeIndex} value={form.buildingType} onChange={(code) => setField("buildingType", code)} />
          {showErrors && !form.buildingType && <div className="snote bad">შენობის ტიპი სავალდებულოა</div>}
        </section>
      </div>

      <div className="bcol">
        <section className="bcard">
          <div className="bcard-h">
            <h4>დოკუმენტი</h4>
            <p>TOTAL-ის სათაური, როგორც კომპანიის შაბლონში</p>
          </div>
          <div className="fgrid g2">
            <div className="fld wide">
              <label htmlFor="ps-doc">დოკუმენტის დასახელება</label>
              <input id="ps-doc" {...field("docTitle")} />
            </div>
            <div className="fld">
              <label htmlFor="ps-docno">დოკ. ნომერი</label>
              <input id="ps-docno" value={docNumber || "ავტომატურად"} readOnly />
            </div>
            <div className="fld">
              <label htmlFor="ps-by">მოამზადა</label>
              <input id="ps-by" {...field("preparedBy")} />
            </div>
          </div>
          <div>
            <div className="pcap">Excel-ში, TOTAL-ის თავში</div>
            <div className="tblk" data-no-translate="true">
              <span className="band">პროექტის დასახელება: {form.name || "—"}</span>
              <div>
                <span>თარიღი: {form.date || "—"}</span>
                <span>დამკვეთი: {customerName || "—"}</span>
              </div>
              <div>
                <span>დოკ. ნომერი: {docNumber || "—"}</span>
                <span>მოამზადა: {form.preparedBy || "—"}</span>
              </div>
              <div>
                <span>დოკ. დასახელება: {form.docTitle || "—"}</span>
                <span>მდებარეობა: {form.location || "—"}</span>
              </div>
            </div>
          </div>
        </section>

        <section className="bcard">
          <div className="bcard-h">
            <h4>ვალუტა</h4>
            <p>ფასები ძირითად ვალუტაში; დამატებითი — კურსით</p>
          </div>
          <div className="fgrid g3">
            <div className="fld">
              <label htmlFor="ps-cur">ძირითადი *</label>
              <select id="ps-cur" {...field("currency")}>
                {CURRENCIES.map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="fld">
              <label htmlFor="ps-cur2">დამატებითი</label>
              <select id="ps-cur2" {...field("currency2")}>
                <option value="">არ არის</option>
                {CURRENCIES.filter((c) => c.value !== form.currency).map((c) => (
                  <option key={c.value} value={c.value}>
                    {c.label}
                  </option>
                ))}
              </select>
            </div>
            <div className="fld">
              <label htmlFor="ps-rate">კურსი</label>
              <div style={{ display: "flex", gap: 6 }}>
                <input id="ps-rate" className="num" disabled={!form.currency2} {...field("rate")} />
                <button type="button" className="ib" disabled={!form.currency2} onClick={onRefreshRate} title="ეროვნული ბანკის კურსი">
                  ↻
                </button>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
